import { Spacings, Fonts, mediaQuery } from '@styles/index';
import Button from '@base/Button/Button';
import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import Image from '@base/Image';
import { getBulletPoints } from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/Unattempted';

const TabletContainer = styled(Paper)`
  display: none;
  ${mediaQuery.onlyTablet} {
    display: block;
    top: -${Spacings.SPACING_8B};
    width: 100%;
    position: relative;
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
    margin-bottom: ${Spacings.SPACING_8B};
  }
`;
const Imagecontainer = styled.div`
  float: right;
  width: 25%;
  padding-right: 50px;
`;

const HeaderTitle = styled.div`
  font-size: ${Fonts.H4};
  font-weight: ${Fonts.HEAVY};
  line-height: 26px;
  color: var(--color-text-primary);
  margin: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_2B};
`;

const HeaderLabel = styled.div`
  font-size: ${Fonts.P1};
  line-height: ${Spacings.SPACING_5B};
  color: var(--color-text-secondary);
  margin-bottom: ${Spacings.SPACING_4B};
`;

const Point = styled.div`
  margin-bottom: ${Spacings.SPACING_2B};
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  font-size: ${Fonts.H7};
  line-height: ${Spacings.SPACING_4B};
  color: var(--color-text-primary);
  margin-left: ${Spacings.SPACING_3B};
`;

const TabletStyledBtn = styled(Button)`
  width: 90px;
  height: ${Spacings.SPACING_10B};
  min-height: ${Spacings.SPACING_10B};
  margin-top: ${Spacings.SPACING_4B};
  border-radius: ${Spacings.SPACING_2B};
  font-size: ${Fonts.H6};
  font-weight: 700;
`;

const DSTTablet = ({ data, takeTest }) => {
  const bulletPoints = getBulletPoints(data.data[0]);
  const { header, subHeader } = data.extraBlockInfo || {};

  return (
    <TabletContainer className="container">
      <Imagecontainer>
        <Image
          src="/dst/trophy-mobile.svg"
          height={1000}
          width={1000}
          alt="dst-trophy"
        />
      </Imagecontainer>
      <HeaderTitle>{header}</HeaderTitle>
      <HeaderLabel>{subHeader}</HeaderLabel>
      {bulletPoints.map(({ text }) => {
        return (
          <Point key={text}>
            <Image
              src="/dst/tick.svg"
              height={18}
              width={18}
              alt="dst-points"
            />
            <Text>{text}</Text>
          </Point>
        );
      })}
      <TabletStyledBtn
        // @ts-ignore
        label="Take test"
        variant="hollow"
        color="green"
        onClick={takeTest}
      />
    </TabletContainer>
  );
};

export default DSTTablet;
